import React from "react";
import OfferEditorCommon from "./OfferEditorCommon";
import { EDITABLE_FIELDS } from "./EDITABLE_FIELDS";

/*
 * Recruiter (draft / sent-back) editor.
 *
 * The editable field list is NOT decided here. It comes from
 * EDITABLE_FIELDS.recruiter, which mirrors hr_backend/src/config/
 * offerEditableFields.js — the list the backend actually enforces on
 * PUT /offers/:id/draft. Never fall back to a wider list: the UI would then
 * offer edits the backend silently discards.
 */

const editableFields = EDITABLE_FIELDS.recruiter || [];

export default function RecruiterOfferEditor(props) {
  const offer = props?.offer || props?.editingOffer || {};
  const status = String(offer?.offer_status || "").trim();

  const isSentBack = status === "Sent Back";
  const isDraft = status === "Draft";

  return (
    <OfferEditorCommon
      {...props}
      title={isSentBack ? "Update & Resubmit Offer" : "Edit Offer"}
      stageLabel="Recruiter"
      editableFields={editableFields}
      showAllFields={true}
      note={
        isSentBack
          ? "This offer was sent back for correction. Update the allowed fields and use Update & Send to continue the workflow."
          : isDraft
            ? "You can update this draft before submitting it for approval."
            : "Recruiter can update only recruiter-editable fields."
      }
    />
  );
}
